
export const transformarCoberturasParaTabla = (coberturaMedicos, nombrePrestador) => {
  if (!coberturaMedicos || typeof coberturaMedicos !== 'object') {
    return [];
  }

  return Object.entries(coberturaMedicos).flatMap(([codigoPrestador, coberturasSeleccionadas]) => {
    if (!Array.isArray(coberturasSeleccionadas)) {
      return [];
    }

    return coberturasSeleccionadas.map((cobertura) => ({
      codigoCobertura: cobertura.id || cobertura.value,
      cobertura: cobertura.cobertura || cobertura.label,
      codigoPrestador,
      nombrePrestador: cobertura.medico.nombreMedico,
      status: cobertura.status || "seleccionado",
    }));
  });
};

export const cargarCoberturasPaciente = (numeroIngreso, nombrePrestador, getHojaQuirurgica) => {
  if (!numeroIngreso) {
    return [];
  }

  const hojaQuirurgica = getHojaQuirurgica(numeroIngreso);
  
  if (!hojaQuirurgica?.coberturaMedicos) {
    return [];
  }

  return transformarCoberturasParaTabla(hojaQuirurgica.coberturaMedicos, nombrePrestador);
};

export const esCoberturaValida = (cobertura) => {
  return cobertura && 
         (cobertura.id || cobertura.value) && 
         (cobertura.cobertura || cobertura.label);
};

export const filtrarCoberturasValidas = (coberturas) => {
  if (!Array.isArray(coberturas)) {
    return [];
  }

  return coberturas.filter(esCoberturaValida);
};
